<template>
    <div>
        <div class="row" v-for="(good) in goodsarr2" v-bind:key="good.id" @click="levelup(good)">
        <hr />
        <div class="col-xs-3" @click="showSwal('input-field', good)" style="padding-left: 15px;">
<!--            <span v-html="photo_src(good)"></span>-->
        </div>
        <div class="col-xs-9" style="padding-left: 5px;">
            <div class="row">
                <div class="col-xs-12" style="padding-right: 3px; padding-left: 3px;">
                    <div class="td-name pull-left">{{good.name}}</div>
                </div>
            </div>
            <div class="row" style="width: 100%;">
                <div class="col-xs-6" style="padding-left: 0px;padding-right: 0;">
                    <div class="col-xs-5" style="padding-left: 0px;padding-right: 3px;">
                        <div class="td-sum">
                            <template v-if="good.price">
                                {{good.price +  ''}}
                            </template>
                        </div>
                    </div>
                    <div class="col-xs-7" style="padding-left: 10px;padding-right: 5px;">
                        <div class="td-order">
                            <template v-if="order.find(x => x.good === good.id)">
                                <p><span class="">х {{order.find(x => x.good === good.id).quantity}} </span> {{good.unit}}</p>
                            </template>
                        </div>
                    </div>
                    <div class="col-xs-10" style="padding: 0px;">
                        <div class="td-order">
                            <template v-if="order.find(x => x.good === good.id)">
                                <!--                                    <p class="text-right"> = {{sumrow(good.id)}} р.</p>-->
                            </template>
                        </div>
                    </div>
                </div>
                <div class="col-xs-6" style="padding-left: 0px;padding-right: 0;">
                    <div class="col-xs-6" style="padding-left: 0px;padding-right: 0;">
                        <template v-if="good.isgroup === 0">
                            <!--                                                <div class="btn-group float-right">-->
                            <button class="btn btn-default" @click="remove_good(good)"><i class="ti-minus" ></i></button>
                            <!--                                                </div>-->
                        </template>
                    </div>
                    <div class="col-xs-6" style="padding-left: 0px;padding-right: 15px;">
                        <template v-if="good.isgroup === 0">
                            <!--                                                <div class="btn-group">-->
                            <button class="btn btn-default" @click="add_good(good)"><i class="ti-plus" ></i></button>
                            <!--                                                </div>-->
                        </template>
                    </div>
                </div>
            </div>
            <!--                        </div>-->
        </div>

    </div>
    </div>
</template>

<script>
  export default {
    name: 'GoodsList',
    props: {
      goodsarr2: undefined,
      order: undefined
    }
  }
</script>

<style scoped>
    .td-actions{
        width: 6rem;
    }
    .td-order{
        font-size: 1.8rem;
        min-width: 90px;
        padding-right: 20px;
        color: #5cb85c;
        font-weight: 600;
    }
    .img-container{
        padding-left: 25px;
        width: 100%;
    }
    .td-name{
        font-size:1.3rem;
        margin-right: 2rem;
    }
    .td-number{
        font-size: 1.4rem;
        color: #484541;
    }
    .td-sum{
        font-size: 1.6rem;
        min-width: 90px;
        color: #484541;
        font-weight: 600;
    }
    .row{
        margin: 0px;
    }
    hr{
        margin: 1rem;
    }
    img{
        min-width: 100px;
    }
    /*.row{*/
    /*}*/
    /*body.swal2-shown:not(.swal2-no-backdrop):not(.swal2-toast-shown) { overflow-y: visible !important; }*/
    body.swal2-shown {
        position: static;
    }

    a {
        color: #000000;
    }
</style>


// WEBPACK FOOTER //
// src/components/UIComponents/Custom/GoodsList.vue